module.exports = __webpack_public_path__ + "img/img0404.16c3df78.png";